import React, { useEffect, useState } from "react";
import EpInlineLoader from "../common/EpInlineLoader";
import { formatBookingData } from "../utilities/utilities";
import classNames from "classnames";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";


function ReviewDetails({
  values,
  errors,
  dirty,
  handleOnChange,
  setData,
  useForm,
  navigation,
  step,
  t,
}) {

  const { paymentOptions ,showUploadDocument} = values;
  const {
    showNationalIdNumber, showPassportNumber,
    showReferenceNumber, showNotes,
    showDateCollect,
    isDelivery,
    showReceiptNumber, 
    isAttestationService, 
    showAttestationTypeList, 
     showExpiryDate ,
     showPassportIssueDate,
     showDateOfBirth,
     showOccupation,
     showAcknowledgment
    } = values.configuration;
    

    

  const [acceptedTerms, setAcceptTerms] = useState(false);
  const [acceptedTerms1, setAcceptTerms1] = useState(false);
  const [acceptedCOD, setAcceptCOD] = useState(values.isOnlinePayment);


  const [modalShow, setModalShow] = React.useState(false);
  const[acknowledgmentShow,setAcknowledgmentShow]=React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const setOverlayLoader = (status) => {
    setData({ name: "isLoading", value: status });
    setData({ name: "loaderText", value: t("PLEASE_WAIT_WHILE_WE_REDIRECT_TO_PAYMENT_GATEWAY") });
    if (status === true) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
  useEffect(() => {
    window.scrollTo(0, 0);
    if (isAttestationService === 0)
      setAcceptTerms(true);

  }, [])

  const handlCloseModal = () => {
    setModalShow(false);
  };

  const handlCloseAcknowledgment = () => {
    setAcknowledgmentShow(false);
  };

  const handleScheduleBooking = () => {
    navigation.go("payment-scheduled");
  };

  const handleAcceptTerms = () => {
    if (acceptedTerms) {
      setAcceptTerms(false);
    } else {
      setAcceptTerms(true);
    }
  }

  const handleAcceptTerms1 = () => {
    if (acceptedTerms1) {
      setAcceptTerms1(false);
    } else {
      setAcceptTerms1(true);
    }
  }

  const handleAcceptCOD = () => {
    if (acceptedCOD) {
      setAcceptCOD(false);
    } else {
      setAcceptCOD(true);
    }
  }

  const handleAcknowledgment=async()=>{
    
    if(showAcknowledgment===1)
      setAcknowledgmentShow(true);
    else 
       handleSaveBooking();
  }

  const handleSaveBooking = async () => {
    handlCloseAcknowledgment();
    setOverlayLoader(true);

    const bookingData = formatBookingData(values);
    const response = await fetch(
      process.env.REACT_APP_PRODUCTS_API_BASE_URL +
      "/services/embassy/api/Orders/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + values.accessToken,
        },
        body: JSON.stringify(bookingData),
      }
    );

    if (response.ok) {
      const result = await response.json();
      if (result.paymentUrl) {
        window.location.href = result.paymentUrl;
      } else {
        setOverlayLoader(false);
      }
    } else {

      if (response.status == 400) {
        setErrorMessage(await response.text());
        setModalShow(true);
        setOverlayLoader(false);
      } else {
        setErrorMessage(t("UNEXPECTED_ERROR_OCCURED"));
        setModalShow(true);
        setOverlayLoader(false);
      }
    }



  };

  const generateName = () => {
    const nameArr = [];
    if (values.firstName) {
      nameArr.push(values.firstName);
    }

    if (values.secondName) {
      nameArr.push(values.secondName);
    }

    if (values.thirdName) {
      nameArr.push(values.thirdName);
    }

    if (values.lastName) {
      nameArr.push(values.lastName);
    }

    return nameArr.join(" ");
  }

  return (
    <>
      <Modal
        show={modalShow}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Error
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>{errorMessage}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {showAcknowledgment === 1 &&
      <Modal
        show={ acknowledgmentShow}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
          {t("ACKNOWLEDGMENT")}:
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5> {values.acknowledgmentMessage.en ? values.locale === "en" ? values.acknowledgmentMessage.en  : values.acknowledgmentMessage.ar : ""}</h5>
        </Modal.Body>
        <Modal.Footer>

        <button type="button" class="btn btn-secondary btn-lg"   onClick={handlCloseAcknowledgment}>{t("CANCEL")}</button>
        <button type="button" class="btn btn-primary" onClick={handleSaveBooking}>{t("AGREE")}</button>
       
        </Modal.Footer>
      </Modal>
   }
      <div className="row g-4">
        <div className="col-sm-12 col-lg-7 ">
          <div className="review-details p-4">
            <h4>
              <img src="./images/user-icon.svg" alt="User Icon" />
              {t("REVIEW_YOUR_DETAILS")}
            
               <button
                className="btn btn-edit mx-3"
                onClick={() => navigation.go("address-details")}
              >
                {t("EDIT")}
              </button>
              
             
            </h4>
            <div className="row mt-4">
              <div className="col-sm-12 col-md-12 mb-4">
                <span>{t("NAME")}</span>
                <span className="highlight">
                  {generateName()}
                </span>
              </div>
              {showDateCollect === 1 && showUploadDocument === 0 &&
                <div className="row">
                  <div className="col-sm-12 col-md-6 mb-4">
                    <span>{ isDelivery==0? t("PREFERRED_DATE") : t("PREFERRED_DATE_DELIVERY")}</span>
                    <span className="highlight">{values.dateSlot || ""}</span>
                  </div>

                  <div className="col-sm-12 col-md-6 mb-4">
                    <span>{isDelivery==0 ? t("PREFERRED_TIME"): t("PREFERRED_TIME_DELIVERY")}</span>
                    <span className="highlight"> {values.timeSlotText || ""}</span>
                  </div>
                </div>
              }


              <div className="col-sm-12 col-md-12 mb-4">
                <span>{t("EMAIL_ADDRESS")}</span>
                <span className="highlight">{values.emailAddress || ""}</span>
              </div>
              <div className="col-sm-12 col-md-12 mb-4">
                <span>{t("MOBILE_NUMBER")}</span>
                <span className="highlight">{values.mobileNumber || ""}</span>
              </div>
              
              {showExpiryDate === 1 &&
                <div className="row">
                  <div className="col-sm-12 col-md-6 mb-4">
                    <span>{t("VISA_EXPIRY_DATE")}</span>
                    <span className="highlight">{values.visaExpiryDate}</span>
                  </div>

                  <div className="col-sm-12 col-md-6 mb-4">
                    <span>{t("PASSPORT_EXPIRY_DATE")}</span>
                    <span className="highlight"> {values.passportExpiryDate}</span>
                  </div>
                </div>
              }
               
              {showPassportIssueDate === 1 && (
                <div className="col-sm-12 col-md-6 mb-4">
                  <span>{t("PASSPORT_ISSUE_DATE")}</span>
                  <span className="highlight">{values.passportIssueDate || ""}</span>
                </div>
              )}

              {showDateOfBirth === 1 && (
                <div className="col-sm-12 col-md-6 mb-4">
                  <span>{t("DATE_OF_BIRTH")}</span>
                  <span className="highlight">{values.dateOfBirth || ""}</span>
                </div>
              )}
              {showOccupation === 1 && (
                <div className="col-sm-12 col-md-6 mb-4">
                  <span>{t("OCCUPATION")}</span>
                  <span className="highlight">{values.occupation || ""}</span>
                </div>
              )}
              {showReceiptNumber === 1 && (<div className="col-sm-12 col-md-6 mb-4">
                <span>{t("RECEIPT_NUMBER")}</span>
                <span className="highlight">{values.receiptNumber || ""}</span>
              </div>)}
              {showReferenceNumber === 1 && (<div className="col-sm-12 col-md-6 mb-4">
                <span>{t("USER_REFERENCE_NUMBER")}</span>
                <span className="highlight">{values.applicationReferenceNumber || ""}</span>
              </div>)}
              {showNationalIdNumber === 1 && <div className="col-sm-12 col-md-6 mb-4">
                <span>{t("NATIONAL_ID_NUMBER")}</span>
                <span className="highlight">{values.nationalIdNumber || ""}</span>
              </div>
              }
              {showPassportNumber === 1 && (<div className="col-sm-12 col-md-12 mb-4">
                <span>{t("PASSPORT_NUMBER")}</span>
                <span className="highlight">{values.passportNumber || ""}</span>
              </div>)}
              <div className="col-sm-12 col-md-6 mb-4">
                <span>{t("CITY")}</span>
                <span className="highlight">{values.cityName || ""}</span>
              </div>
              <div className="col-sm-12 col-md-6  mb-4">
                <span>{t("AREA")}</span>
                <span className="highlight">{values.areaNameText || ""}</span>
              </div>
              <div className="col-sm-12 col-md-6 mb-4">
                <span>{t("STREET_NAME")}</span>
                <span className="highlight">{values.streetName || ""}</span>
              </div>
              <div className="col-sm-12 col-md-6 mb-4">
                <span>{t("BUILDING")}</span>
                <span className="highlight">{values.building || ""}</span>
              </div>
              <div className="col-sm-12 mb-4 col-md-6">
                <span>{t("FLOOR")}</span>
                <span className="highlight">{values.floor || ""}</span>
              </div>
              <div className="col-sm-12  col-md-6  mb-4">
                <span>{t("APARTMENT_NO_VILLA")}</span>
                <span className="highlight">{values.apartmentNo || ""}</span>
              </div>
              <div className="col-sm-12 mb-4">
                <span>{values.fullAddress ? t("FULL_ADDRESS") : ""} </span>
                <span className="highlight">{values.fullAddress || ""}</span>
              </div>
              {showNotes === 1 && <div className="col-sm-12 mb-4">
                <span>{t("NOTES")}</span>
                <span className="highlight">{values.notes || ""}</span>
              </div>
              }


            </div>

          </div>
          <div className="col-6 my-3 dir-left">
            <button
              className="btn btn-lg btn-default btn-back "
              onClick={() => navigation.go("address-details")}
              disabled={false}
            >
              <img src="./images/arrow-left.svg" alt="" />
              {t("BACK")}
            </button>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-5 payment-details-sec">
        
        {isAttestationService === 0 && 
           <div className="review-details p-4">

              <div className="col-sm-12 mb-2">
            <span>{t("SERVICE_NAME")}</span>
            <span className="highlight">{values.serviceTypeName} </span>
          </div>           
          </div>
        }
          
          {isAttestationService === 1 && 
            <div className="review-details p-4">
              <h6>
                  {isDelivery==0 &&
                  <button
                  className="btn btn-edit mx-2"
                  onClick={() => navigation.go("attestation-service")}
                >
                  {t("EDIT")}
                </button>        
              }
                
              </h6>
              <div className="col-sm-12 mb-2">
            <span>{t("SERVICE_NAME")}</span>
            <span className="highlight">{values.serviceTypeName} </span>
          </div>
              <div className="col-sm-12 mb-2">
                <span>{t("COLLECTION_ATTESTATION")}</span>
                <span className="highlight">{values.attestationNatureName} </span>
              </div>

              <div className="col-sm-12 mb-2">
                <span>{t("TOTAL_ATTEST_NUMS")}</span>
                <span className="highlight"> {values.numberOfDocument}</span>
              </div>


              {showAttestationTypeList === 1 &&
                <div className="col-sm-12 mb-2">
                  <span>{t("TYPE_ATTESTATION")}</span>
                  <span className="highlight long_text">{values.SpecialNotes}</span>
                </div>
              }

            </div> }




          <div className="payment-details p-4">
            {isAttestationService === 1 && <div className="row">
              <div className="col-7 dir-left">{t("SERVICE_CHARGES")}</div>
              <div className="col-5 dir-right">
                {t("AED")} {parseFloat(values.attestationServiceCharges).toFixed(2)}
              </div>
            </div>
            }


            <div className="row">
              <div className="col-7 dir-left">{t("TOTAL_BEFORE_VAT")}</div>
              <div className="col-5 dir-right">
                {t("AED")} {parseFloat(values.amount).toFixed(2)}
              </div>

            </div>
            <div className="row">
              <div className="col-7 dir-left">{t("VAT_PERCENT")}</div>
              <div className="col-5 dir-right">
                {t("AED")} {parseFloat(values.vat).toFixed(2)}
              </div>
            </div>
            {isAttestationService === 1 &&

              <div className="row">
                <div className="col-7 dir-left">{t("QUANTITY")}</div>
                <div className="col-5 dir-right">
                  {values.numberOfDocument}
                </div>
              </div>
            }


            <hr />
            <div className="row total-price-section">
              <div className="col-7 dir-left">{t("TOTAL_INCLUDING_VAT")}</div>
              <div className="col-5 dir-right">

                <span className="total-amount">
                  {t("AED")} {(parseFloat(values.totalAmount)).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 my-3">
            {isAttestationService === 1 &&
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="accept-terms"
                  onChange={handleAcceptTerms}
                />
                <label className="form-check-label" htmlFor="accept-terms">
                  <span className=""> {t("TERMS_CONDITIONS1")}</span>
                </label>
              </div>
            }

            {
              !values.isOnlinePayment && <div className="col-sm-12 my-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="accept-cod"
                    onChange={handleAcceptCOD}
                  />
                  <label className="form-check-label" htmlFor="accept-cod">

                    <span className=""> {t("CASH_ON_DELIVERY_CONFIRMATION")}</span>
                  </label>
                </div>
              </div>
            }
            <div className="col-sm-12 my-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="accept-terms"
                  onChange={handleAcceptTerms1}
                />
                <label className="form-check-label" htmlFor="accept-terms">

                <a href="https://www.emx.ae/terms-and-conditions" target="_blank" className="a-link" rel="noreferrer">

               
                <h5 className=""> {t("TERMS_CONDITIONS")}</h5>
                </a>
                
                </label>
              </div>
            </div>

          </div>
          <div className={classNames({ "col-sm-12 mt-3 d-grid": true, "app-grid-col-2 gap-3": paymentOptions.length > 1 })}>
            {paymentOptions.includes("CREDIT") && (
              <button
                className="btn btn-primary btn-lg d-block emx-button"
                onClick={handleAcknowledgment}
                disabled={!acceptedTerms || !acceptedTerms1 || !acceptedCOD}
              >
                {values.isLoading && (<div><EpInlineLoader /></div>)}
                {!values.isLoading && (
                  <div className="row">
                    {values.isOnlinePayment == true &&
                      <div className={classNames({ "col-10 dir-left": paymentOptions.length === 1 })}>{paymentOptions.lenth === 1 ? t("PAY_NOW") : t("CONTINUE_TO_PAYMENT")}</div>
                    }

                    {values.isOnlinePayment == false &&
                      <div className="col-10 dir-left">{t("PAY_AT_DELIVERY")}</div>
                    }

                    {paymentOptions.length === 1 && <div className="col-2 dir-right"><img src="./images/btn-arrow-right.svg" alt="arrow right" className="payment-arrow" /></div>}
                  </div>
                )}

              </button>
            )}
            {paymentOptions.includes("COD") && <button onClick={handleScheduleBooking} className="btn btn-outline-primary app-border-2 app-bold">{t("PAY_AT_DELIVERY")}</button>}
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewDetails;
